import React from "react";
import SectionTitle from "./SectionTitle";
import GuestScrollReveal from "./GuestScrollReveal";
import starIcon from "../../media/guestpage/starIcon.svg";
import { GUEST_FEATURES, GUEST_SECTION_IDS } from "../../data/guestPageData";

const FeaturesSection = () => {
    return (
        <section
            className="guest-section guest-section--features"
            id={GUEST_SECTION_IDS.features}
        >
            <GuestScrollReveal>
                <SectionTitle>
                    <span>ЧТО МЫ ДАЕМ </span>
                    <span className="guest-section-title__accent">ИГРОКАМ?</span>
                </SectionTitle>
            </GuestScrollReveal>

            <div className="guest-section__content guest-features">
                {GUEST_FEATURES.map((feature, index) => (
                    <GuestScrollReveal
                        key={feature.id}
                        className="guest-feature-card-wrap"
                        delay={index * 0.05}
                    >
                        <article className="guest-feature-card">
                            <div className="guest-feature-card__top">
                                <div className="guest-feature-card__header">
                                    <span className="guest-feature-card__number">
                                        {feature.id}
                                    </span>
                                    <img
                                        src={starIcon}
                                        alt=""
                                        aria-hidden="true"
                                        className="guest-feature-card__icon"
                                    />
                                </div>
                                <p className="guest-feature-card__text">
                                    {feature.text}
                                </p>
                            </div>
                            <img
                                className="guest-feature-card__image"
                                src={feature.image}
                                alt=""
                            />
                        </article>
                    </GuestScrollReveal>
                ))}
            </div>
        </section>
    );
};

export default FeaturesSection;
